export default from './category-description';



// WEBPACK FOOTER //
// ./app/components/category-description/index.js